import React, { useEffect, useMemo, useState } from "react";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import { Tabs, Tab } from "@mui/material";
import { useStateAuthValue } from "../../context/AuthState";
import { useNavigate } from "react-router-dom/dist";
import encode from "jwt-encode";
import { getAllReports } from "../../services/reportsService";
import { showToast, ToastType } from "../../utils/ToastUtil";
import { useToast } from "../../context/Toast/ToastProvider";
import PageHeader from "../../components/PageHeader";
import Colors from "../../theme/Colors";
import { resolveSpecialUserView } from "./specialUserViewsConfig";

// Tabs con scroll automático: escala a cualquier cantidad de docs sin
// necesitar rediseño (a diferencia de una fila fija de pills).
const DocSelector = ({ docs, selectedKey, onSelect }) => (
  <Tabs
    value={selectedKey}
    onChange={(_, value) => onSelect(value)}
    variant="scrollable"
    scrollButtons="auto"
    allowScrollButtonsMobile
    sx={{
      backgroundColor: "#fff",
      borderRadius: "12px",
      boxShadow: "0 2px 10px rgba(0,44,84,0.08)",
      marginBottom: "1.5rem",
      minHeight: "56px",
      "& .MuiTabs-indicator": {
        height: "3px",
        borderRadius: "3px",
        background: "linear-gradient(195deg, #002C54, #003f77)",
      },
    }}
  >
    {docs.map((doc) => (
      <Tab
        key={doc.key}
        value={doc.key}
        label={doc.label}
        sx={{
          textTransform: "none",
          fontWeight: 700,
          fontSize: "15px",
          minHeight: "56px",
          color: Colors.Azul75,
          "&.Mui-selected": { color: Colors.AzulMediline },
        }}
      />
    ))}
  </Tabs>
);

export const SpecialUserView = () => {
  const [{ userToken }] = useStateAuthValue();
  const navigate = useNavigate();
  useEffect(() => {
    if (!userToken) {
      navigate("/login");
    }
    return () => {};
  }, [userToken]);
  const username = localStorage.getItem("username");
  const descriptor = resolveSpecialUserView(username);
  const docs = descriptor?.type === "swagger" ? descriptor.docs : [];
  const [selectedDocKey, setSelectedDocKey] = useState(docs[0]?.key);
  const bust = useMemo(() => `?v=${Date.now()}`, []);
  const selectedDoc = docs.find((doc) => doc.key === selectedDocKey);
  const swaggerFile = selectedDoc ? `${selectedDoc.url}${bust}` : "";
  const [url, setUrl] = useState("");
  const embeber = (token, dashboard, params) => {
    const payload = {
      resource: { dashboard: dashboard },
      params: params,
      exp: Math.round(Date.now() / 1000) + 120 /*minutos*/ * 60 /*segundos*/,
    };
    const tokenJWT = encode(payload, token);
    const url =
      process.env.REACT_APP_API_URL +
      `/embed/dashboard/${tokenJWT}#bordered=true&titled=true`;
    return url;
  };
  const toastDispatch = useToast();

  const displayError = (msg) =>
    showToast(toastDispatch, msg, ToastType.ERROR, ToastType.ERROR);
  const GetReports = async () => {
    let reportsGet = await getAllReports(userToken, displayError);
    let report = reportsGet?.find(
      (element) => element.name === descriptor.reportName
    );
    if (report) {
      setUrl(
        embeber(report.secrey_key, parseInt(report.remote_id, 10), descriptor.params)
      );
    }
  };
  useEffect(() => {
    if (descriptor?.type === "report") {
      GetReports();
    }
  }, []);
  const handleRender = () => {
    if (!descriptor) {
      return (
        <div>
          <h1>No hay vistas creadas</h1>
        </div>
      );
    }
    if (descriptor.type === "swagger") {
      return (
        <div>
          {docs.length > 1 && (
            <>
              <PageHeader
                title="Documentación API"
                subtitle={selectedDoc?.label}
              />
              <DocSelector
                docs={docs}
                selectedKey={selectedDocKey}
                onSelect={setSelectedDocKey}
              />
            </>
          )}
          <SwaggerUI url={swaggerFile} />
        </div>
      );
    }
    return (
      <div>
        <div className="report">
          {
            <iframe
              src={url}
              className="iframe-report"
              frameBorder="0"
              width="100%"
              height="100%"
              allowtransparency="true"
            ></iframe>
          }
        </div>
      </div>
    );
  };
  return handleRender();
};
